/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useState } from "react";
import styles from "../../../pages/Employer/invoice/Invoice.module.scss";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { CiCalendar } from "react-icons/ci";

import {
  DDMMYYYY_formate,
  Detailsshow,
  MyModal,
  capitalizeWords,
  dateFormateDD,
  decryptedAdminID,
  textTruncate,
} from "../../../utility";
import ModalContainer from "../../modal_popup";
import DetailsContainer from "../../DetailsContainer";
import EmployerDetailsStyle from "./EmployerDetailsview.module.scss";
import { useEffect } from "react";
import {
  GetAllAdminDetails,
  getcandidateDetails,
  getCandidateLead,
  GetEmployerDetailsByid,
  getEmployerDocument,
  getinvoiceCandidate,
  GetInvoiceDataDetails,
  GetInvoiceDetails,
  putInvoiceStatusUpdate,
} from "../../../apiServices";
import companylogo from "../../../assets/images/Company-Logo.png";
import FBStyle from "../../../pages/Candidate/FacebookMeta/candidateFacebookMeta.module.scss";
import { GoDotFill } from "react-icons/go";
import { BsFileEarmarkPostFill, BsThreeDotsVertical } from "react-icons/bs";
import {
  AiFillCalendar,
  AiOutlineClose,
  AiOutlineEdit,
  AiTwotoneFilePdf,
} from "react-icons/ai";
import { useRef } from "react";
import {
  PiDotsThreeOutlineVerticalFill,
  PiWarningCircleLight,
} from "react-icons/pi";
import { LiaUserEditSolid } from "react-icons/lia";
import { FaDownload, FaWhatsapp } from "react-icons/fa";
import flag from "../../../assets/images/flag.png";

import WhatsappImage from "../../../assets/images/whatsapp-logo-removebg-preview.png";
import { MdCall, MdEmail, MdNotificationAdd } from "react-icons/md";
import candidateTabsviewStyle from "../../../pages/Tabsview/Candidate/CandidateTabsview.module.scss";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled as muiStyled } from "@mui/material/styles";
import {
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  tableCellClasses,
  TableBody,
  Stack,
  Pagination,
} from "@mui/material";
import {
  commonPopupActions,
  InvoiceDataFilterAction,
} from "../../../redux-store/store";
import { useDispatch, useSelector } from "react-redux";
import SuccessTick from "../../success_tick";
import styled from "styled-components";
import Document from "../../../pages/invoceDoc/Document";

const VisuallyHiddenInput = muiStyled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: "50px",
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const buttonStyle = {
  // display: 'inline-block',
  margin: "0 auto", // Centers the button horizontally
  marginTop: "5vh", // Centers the button vertically; adjust as needed
};
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#d2d2d2",
    color: "#545454f0",
    minWidth: "130px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    minWidth: "60px",
    // paddingLeft: "30px",
  },
}));
const InvoiceDetailsView = ({ Id }) => {
  const [adminName, setAdminName] = useState([]);
  const [adminid, setAdminId] = useState([]);
  const [openInvoiceDatails, setOpenInvoiceDetails] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState("Download");
  const [invoceCategory, setInvoceCategory] = useState("");
  const invoiceID = Id;
  const [invoiceCandidateData, setInvoiceCandidateData] = useState({
    invoiceId: invoiceID,
    page: 1,
    size: 30,
  });
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [empId, setEmpId] = useState("");
  const [notes, setnotes] = useState("");
  const documentRef = useRef(null);
  const [openNotes, setOpenNotes] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState({
    invoiceDate: {},
    invoiceCandidateDate: [],
  });
  const [dataCount, setDataCount] = useState({
    totalCount: "",
    currentpage: "",
    totalPage: 1,
  });
  const [storeInvoiceCandidateList, setStoreInvoiceCandidateList] = useState(
    []
  );
  const [formData, setFormData] = useState({
    invoiceDate: new Date().toISOString().split("T")[0],
    invoiceNumber: "",
    dueDateFrom: "",
    dueDateTo: "",
    actualAmount: "",
    cgst: "",
    sgst: "",
    gst: "",
    totalAmount: "",
    roundOfAmount: "",
    balanceDue: "",
    candidates: [
      {
        id: "",
        name: "",
        ctc: "",
        category: "",
        joined: "",
        candidateId: "",
        employeeId: "",
        department: "",
        checked: false,
      },
    ],
    notes: "",
  });
  const [activeTab, setActiveTab] = useState(1);
  const adminId = decryptedAdminID();
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const [assignAdminto, setAssignAdminto] = useState({
    candidateId: "",
    adminId: "",
  });
  const [adminDetails, setAdminDetails] = useState({
    id: null,
    adminName: [],
  });

  const Dispatch = useDispatch();
  function handleInvoiceDetailsClose() {
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "invoiceDetailsclose",
      })
    );
    // Dispatch(InvoiceDataFilterAction.setInvoiceempID(""));
  }

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  useEffect(() => {}, [invoiceCandidateData]);
  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      const fetchInvoiceCandidateData = async () => {
        setLoading(true);
        try {
          const response = await GetInvoiceDetails(invoiceCandidateData);
          // console.log(response.data.message, "data");
          setInvoiceDetails((prevDetails) => ({
            ...prevDetails,
            invoiceCandidateDate: response.data.data,
          }));

          // If you need to set pagination data, update this:
          setDataCount((prevDetails) => ({
            ...prevDetails,
            totalCount: response.data.pagination.totalRecords,
            totalPage: response.data.pagination.totalPages,
          }));
        } catch (error) {
          console.error("Error fetching invoice data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchInvoiceCandidateData();
    }, 500);

    return () => clearTimeout(debounceTimeout);
  }, [invoiceCandidateData]);
  useEffect(() => {
    const fetchInvoiceCandidates = async () => {
      try {
        if (!invoiceID) return;

        const formObject = {
          invoiceId: invoiceID,
          page: 1,
          size: 100,
        };

        const data = await GetInvoiceDetails(formObject);

        if (!data?.data?.data || !Array.isArray(data.data.data)) {
          console.error("Invalid data format for invoice candidates:", data);
          return;
        }

        console.log(data.data.data, "data invoice candidate");

        const candidates = data.data.data.map((el) => ({
          id: el.id,
          name: `${el.candidate_first_name} ${
            el.candidate_last_name || ""
          }`.trim(),
          ctc: el.actual_ctc,
          category: el.job_category,
          joined: el.joined_on ? el.joined_on.split("T")[0] : "",
          candidateId: el.can_id,
          employeeId: el.employee_id || "",
          department: el.department || "",
          checked: true,
        }));

        setFormData((prevData) => ({
          ...prevData,
          candidates,
        }));
      } catch (error) {
        console.error("Error fetching invoice candidate data:", error);
      }
    };

    if (openInvoiceDatails) {
      fetchInvoiceCandidates();
    }
  }, [openInvoiceDatails, invoiceID]); // Ensure it re-runs when invoiceID changes
  // Dependency array
  const handleNotesSubmit = async (e) => {
    const payload = {
      invoice_id: invoiceID,
      notes: notes,
    };

    setShowSuccess(true);

    try {
      const result = await putInvoiceStatusUpdate(payload);

      setOpenNotes(false);

      setTimeout(() => {
        setShowSuccess(false);
        setOpenNotes(false);
        setnotes("");
      }, 3000);

      setLoading(true);
      try {
        const data = await GetInvoiceDataDetails(invoiceID);

        if (!data?.result) {
          console.error("No data received for invoice details.");
          return;
        }

        const {
          actual_amount = 0, // Ensure default value
          gst_amount = 0, // Ensure default value
          total_amount = 0, // Ensure default value
          emp_id,
          invoice_date,
          invoice_category,
        } = data.result;

        setInvoiceDetails((prevDetails) => ({
          ...prevDetails,
          invoiceDate: data.result,
        }));

        setEmpId(emp_id);
        setInvoceCategory(invoice_category);

        // Ensure calculations are correct
        const totalAmount = Number(actual_amount) + Number(gst_amount);
        const roundAmount = (totalAmount % 1).toFixed(2); // Correct rounding
        const dueBalance = Math.round(totalAmount).toFixed(2); // Ensure rounding works correctly

        console.log(gst_amount,totalAmount, roundAmount, dueBalance); // Debugging output

          const cgst_amount = actual_amount * 0.09;
          const sgst_amount = actual_amount * 0.09;

        setFormData((prevForm) => ({
          ...prevForm,
          invoiceDate: invoice_date,
          totalAmount,
          cgst: cgst_amount,
          sgst: sgst_amount,
          gst: gst_amount,
          actualAmount: actual_amount,
          roundOfAmount: roundAmount,
          balanceDue: dueBalance,
        }));
      } catch (error) {
        console.error("Error fetching invoice data:", error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error updating invoice status:", error);
    }
  };

  const invoiceNumber = invoiceDetails.invoiceDate.invoice_no;

  // console.log(invoiceNumber, "invoiceNumber");

  const handleClickDownloadInvoice = async () => {
    if (
      documentRef.current &&
      typeof documentRef.current.generatePDF === "function"
    ) {
      setDownloadStatus("Downloading...");

      try {
        await documentRef.current.generatePDF();

        setDownloadStatus("Downloaded");

        setTimeout(() => {
          setDownloadStatus("Download");
        }, 2000);
      } catch (error) {
        console.error("Error generating PDF:", error);
        setDownloadStatus("Download");
      }
    } else {
      console.error(
        "documentRef.current is not properly assigned or generatePDF is missing"
      );
    }
  };

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      const fetchInvoiceData = async () => {
        if (!invoiceID) return;

        setLoading(true);
        try {
          const data = await GetInvoiceDataDetails(invoiceID);

          if (!data?.result) {
            console.error("No data received for invoice details.");
            return;
          }

          const {
            actual_amount = 0, // Ensure default value
            gst_amount = 0, // Ensure default value
            total_amount = 0, // Ensure default value
            emp_id,
            invoice_date,
            invoice_category,
          } = data.result;

          setInvoiceDetails((prevDetails) => ({
            ...prevDetails,
            invoiceDate: data.result,
          }));

          setEmpId(emp_id);
          setInvoceCategory(invoice_category);

          // Ensure calculations are correct
          const totalAmount = Number(actual_amount) + Number(gst_amount);
          const roundAmount = (totalAmount % 1).toFixed(2); // Correct rounding
          const dueBalance = Math.round(totalAmount).toFixed(2); // Ensure rounding works correctly
          const cgst_amount = actual_amount * 0.09;
          const sgst_amount = actual_amount * 0.09;

          console.log(totalAmount, roundAmount, dueBalance); // Debugging output

          setFormData((prevForm) => ({
            ...prevForm,
            invoiceDate: invoice_date,
            totalAmount,
            gst: gst_amount,
            cgst: cgst_amount,
            sgst: sgst_amount,
            actualAmount: actual_amount,
            roundOfAmount: roundAmount,
            balanceDue: dueBalance,
          }));
        } catch (error) {
          console.error("Error fetching invoice data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchInvoiceData();
    }, 500);

    return () => clearTimeout(debounceTimeout);
  }, [invoiceID]);

  const dueDateFrom = invoiceDetails.invoiceDate.start_period;
  const dueDateTo = invoiceDetails.invoiceDate.end_period;
  // useEffect(() => {
  //   const fetchInvoiceCandidates = async () => {
  //     try {
  //       const formObject = {
  //         startDate: dueDateFrom,
  //         endDate: dueDateTo,
  //         empId: empId,
  //       };

  //       const data = await getinvoiceCandidate(formObject);
  //       const storeData = data.result.map((el) => el);
  //       // setStoreInvoiceCandidateList(storeData);

  //       const candidates = data.result.map((el) => ({
  //         id: el.id,
  //         name: `${el.first_name} ${el.last_name || ""}`.trim(),
  //         ctc: el.ctc,
  //         category: el.job_category,
  //         joined: el.joined_on ? el.joined_on.split("T")[0] : "",
  //         candidateId: el.can_id,
  //       }));

  //       setFormData((prevData) => ({
  //         ...prevData,
  //         candidates,
  //       }));

  //       // setStep(2);
  //     } catch (error) {
  //       console.error("Error fetching invoice candidate data:", error);
  //     }
  //   };

  //   fetchInvoiceCandidates();
  // }, [openInvoiceDatails]);
  const calculateDuration = (joinedOn) => {
    const joinedDate = new Date(joinedOn);
    const currentDate = new Date();
    const timeDifference = currentDate - joinedDate;
    return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  };
  function candidatePagination(event, page) {
    const currentPage = page;
    // console.log(event, "current page");
    setInvoiceCandidateData((prev) => ({
      ...prev,
      page: currentPage,
    }));
  }
  useEffect(() => {
    GetAllAdminDetails().then((data) => {
      const adminNames = data.map((item) => item.userName);
      const adminIds = data.map((item) => item.id);
      setAdminName(adminNames);
      setAdminId(adminIds);
    });
  }, []);
  const handleCandidateDetails = async (candidateleadId, type) => {
    let data;
    if (type === "CandidateLead") {
      data = await getCandidateLead(candidateleadId);
    } else if (type === "RegisterCandidate") {
      data = await getcandidateDetails(candidateleadId);
    }

    // Dispatch action to show the popup and pass the fetched data
    Dispatch(
      commonPopupActions.setShowPopup({
        name: "candidateDetails",
        id: candidateleadId,
        type: type,
        data: data,
      })
    );
  };

  return (
    <div>
      <Detailsshow>
        <DetailsContainer
          topComponent={
            <>
              <div className={`${EmployerDetailsStyle.boxcross}`}>
                <div
                  className={` ${EmployerDetailsStyle.CrossStyle} pe-5 pe-lg-4`}
                >
                  <b>
                    <RxCross2
                      onClick={() => {
                        handleInvoiceDetailsClose();
                      }}
                    />
                  </b>
                </div>
              </div>
            </>
          }
          childComponent={
            <>
              <div className={`${EmployerDetailsStyle.boxwidth}`}>
                <div className="container-fluid">
                  <div className={`row ${EmployerDetailsStyle.topcontainer}`}>
                    <div className="col-sm-4">
                      <div className="row">
                        <div className="col-sm-4">
                          {" "}
                          {invoiceDetails.invoiceDate.companyLogo ? (
                            <img
                              src={invoiceDetails.invoiceDate.companyLogo}
                              alt="employer Profile"
                              width={80}
                            />
                          ) : (
                            <img src={companylogo} alt="Profile" width={80} />
                          )}
                        </div>
                        <div className="col-sm-6">
                          <div style={{ fontSize: "15px" }}>
                            <b>{invoiceDetails.invoiceDate.company_name}</b>
                          </div>
                          <div className="d-flex gap-2">
                            <div>
                              <b>Invoice No. : </b>
                            </div>
                            <div>
                              {invoiceDetails.invoiceDate.invoice_no ? (
                                <>{invoiceDetails.invoiceDate.invoice_no}</>
                              ) : (
                                <> </>
                              )}{" "}
                            </div>
                          </div>
                          <div>
                            <div className="d-flex gap-2">
                              <div>
                                <b>Invoice Date : </b>
                              </div>
                              <div>
                                {invoiceDetails.invoiceDate.invoice_date ? (
                                  <>
                                    {dateFormateDD(
                                      invoiceDetails.invoiceDate.invoice_date
                                    )}{" "}
                                  </>
                                ) : (
                                  <> </>
                                )}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className={`${EmployerDetailsStyle.Createdon}`}>
                          Created on :{" "}
                          <DDMMYYYY_formate
                            dateValue={invoiceDetails.invoiceDate.created_at}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col">
                      {" "}
                      
                    </div> */}
                    <div className={`col-sm-8`}>
                      <div className="row">
                        <div className="col-sm-5">
                          {/* <div
                            className={`${EmployerDetailsStyle.verticalLine}`}
                          ></div> */}
                          <div
                            className={`${EmployerDetailsStyle.CandidatepastDetails} d-flex  align-items-center`}
                          >
                            <div>
                              <b className="ms-2">Invoice Status</b>{" "}
                              <div className="gap-2 d-flex justify-content-between p-2">
                                {" "}
                                <div className="">
                                  {" "}
                                  Amount&nbsp;Received
                                  {/* <PiWarningCircleLight /> */}
                                </div>
                                <div className="">
                                  {" "}
                                  {invoiceDetails.invoiceDate.amount_received !=
                                  null ? (
                                    <span className="text-success">
                                      <b>Yes</b>
                                    </span>
                                  ) : invoiceDetails.invoiceDate
                                      .payment_status === "pending" ? (
                                    <span className="text-primary">
                                      <b>Email&nbsp;sent&nbsp;/&nbsp;pending</b>
                                    </span>
                                  ) : invoiceDetails.invoiceDate
                                      .payment_status === "cancelled" ? (
                                    <span className="text-danger">
                                      <b>Cancelled</b>
                                    </span>
                                  ) : (
                                    <span className="text-secondary">
                                      <b>No&nbsp;status</b>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-7">
                          <div className={`row `}>
                            <div
                              className={`col-sm-12 ${EmployerDetailsStyle.flexContainer}`}
                            >
                              <button
                                className="btn btn-primary"
                                onClick={() => setOpenNotes(true)}
                              >
                                Add Notes
                              </button>
                              <button
                                className={`btn btn-success ${styles.downloadButton}`}
                                onClick={() => {
                                  setOpenInvoiceDetails(true);
                                }}
                              >
                                <FaDownload /> Invoice Download
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-2 px-4 ">
                    {/* {loading ? (
                      <div className="text-center">
                        {" "}
                        <div className="d-flex align-items-center justify-content-center mt-5">
                          <div className="spinner-border spinner-border-sm text-dark"></div>
                        </div>
                      </div>
                    ) : ( */}
                    <div
                      className={`col-sm-4 pb-4 rounded ${EmployerDetailsStyle.personalDetails}`}
                    >
                      <div className="mt-2">
                        {" "}
                        <h6>
                          <b>Invoice Details</b>
                        </h6>
                        <div
                          className={`row ${EmployerDetailsStyle.CanDetailsRow}`}
                        >
                          <div className="col-5">
                            <div style={{ lineHeight: "2" }}>
                              Invoice Number{" "}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              Invoice Category{" "}
                            </div>
                            <div style={{ lineHeight: "2" }}>Status </div>
                            {invoiceDetails.invoiceDate.reason_for_cancel !=
                              null && (
                              <div style={{ lineHeight: "2" }}>
                                Reason for cancellation{" "}
                              </div>
                            )}{" "}
                            {invoiceDetails.invoiceDate.amount_received !=
                              null && (
                              <div style={{ lineHeight: "2" }}>
                                Received amount{" "}
                              </div>
                            )}{" "}
                            {invoiceDetails.invoiceDate.amount_received !=
                              null && (
                              <div style={{ lineHeight: "2" }}>
                                Amount Adjustment Status{" "}
                              </div>
                            )}
                            <div style={{ lineHeight: "2" }}>
                              {invoiceDetails.invoiceDate.notes ? "Notes" : ""}
                            </div>
                          </div>
                          <div className="col-7">
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.invoice_no != null
                                ? invoiceDetails.invoiceDate.invoice_no
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.invoice_category !=
                              null
                                ? invoiceDetails.invoiceDate.invoice_category
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.payment_status != null
                                ? invoiceDetails.invoiceDate.payment_status ===
                                  "pending"
                                  ? "Email sent / pending"
                                  : invoiceDetails.invoiceDate
                                      .payment_status === "received"
                                  ? "Received"
                                  : "Cancelled"
                                : "-"}
                            </div>
                            {invoiceDetails.invoiceDate.reason_for_cancel !=
                              null && (
                              <div style={{ lineHeight: "2" }}>
                                {capitalizeWords(
                                  invoiceDetails.invoiceDate.reason_for_cancel
                                )}{" "}
                              </div>
                            )}{" "}
                            {invoiceDetails.invoiceDate.amount_received !=
                              null && (
                              <div style={{ lineHeight: "2" }}>
                                {invoiceDetails.invoiceDate.amount_received}{" "}
                              </div>
                            )}{" "}
                            {invoiceDetails.invoiceDate
                              .amount_adjustment_details != null && (
                              <div style={{ lineHeight: "2" }}>
                                {
                                  invoiceDetails.invoiceDate
                                    .amount_adjustment_details
                                }{" "}
                              </div>
                            )}
                            <div style={{ lineHeight: "2" }}>
                              {capitalizeWords(
                                invoiceDetails.invoiceDate.notes
                              )}{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2">
                        {" "}
                        <h6>
                          <b>company Details</b>
                        </h6>
                        <div
                          className={`row ${EmployerDetailsStyle.CanDetailsRow}`}
                        >
                          <div className="col-5">
                            <div style={{ lineHeight: "2" }}>Company Name </div>
                            <div style={{ lineHeight: "2" }}>
                              Contact person{" "}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              Contact Number{" "}
                            </div>

                            <div style={{ lineHeight: "2" }}>Email ID </div>
                            <div style={{ lineHeight: "2" }}>Location</div>
                          </div>
                          <div className="col-7">
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.company_name != null
                                ? invoiceDetails.invoiceDate.company_name
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.cantact_person_name !=
                              null
                                ? invoiceDetails.invoiceDate.cantact_person_name
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.mobile_number != null
                                ? invoiceDetails.invoiceDate.mobile_number
                                : "-"}
                            </div>

                            <div style={{ lineHeight: "2" }}>
                              {invoiceDetails.invoiceDate.email_id != null
                                ? invoiceDetails.invoiceDate.email_id
                                : "-"}
                            </div>

                            <div style={{ lineHeight: "2" }}>
                              {invoiceDetails.invoiceDate.area != null
                                ? invoiceDetails.invoiceDate.area
                                : "-"}
                              ,{" "}
                              {invoiceDetails.invoiceDate.city != null
                                ? invoiceDetails.invoiceDate.city
                                : "-"}{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-2">
                        {" "}
                        <h6>
                          <b>Amount Details</b>
                        </h6>
                        <div
                          className={`row ${EmployerDetailsStyle.CanDetailsRow}`}
                        >
                          <div className="col-5">
                            <div style={{ lineHeight: "2" }}>
                              Actual amount{" "}
                            </div>
                            <div style={{ lineHeight: "2" }}>GST 18% </div>
                            <div style={{ lineHeight: "2" }}>Total amount </div>
                          </div>
                          <div className="col-7">
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.actual_amount != null
                                ? invoiceDetails.invoiceDate.actual_amount
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.gst_amount != null
                                ? invoiceDetails.invoiceDate.gst_amount
                                : "-"}
                            </div>
                            <div style={{ lineHeight: "2" }}>
                              {" "}
                              {invoiceDetails.invoiceDate.total_amount != null
                                ? invoiceDetails.invoiceDate.total_amount
                                : "-"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* // )} */}
                    <div
                      className={`col-sm-8 rounded  ${EmployerDetailsStyle.DailyDetailsupdate}`}
                    >
                      {invoiceDetails.invoiceDate.invoice_category !=
                      "IT Service" ? (
                        <div>
                          <div
                            className={`tab-buttons ${candidateTabsviewStyle.tab_buttons}`}
                          >
                            <div
                              className={`d-flex ${candidateTabsviewStyle.tab_hr}`}
                            >
                              <div
                                onClick={() => handleTabClick(1)}
                                className={` ${
                                  activeTab === 1
                                    ? candidateTabsviewStyle.activetag
                                    : candidateTabsviewStyle.unactivetag
                                } `}
                              >
                                Joined Candidate
                              </div>
                            </div>
                            <hr style={{ borderTop: "10px solid #ccc" }} />
                          </div>

                          <div
                            className={`tab-content ${candidateTabsviewStyle.tab_content}`}
                          >
                            {activeTab === 1 && (
                              <p>
                                <div
                                  className="d-flex  
                              justify-content-between"
                                >
                                  <div className="d-flex gap-2">
                                    <div>
                                      Start Period :{" "}
                                      {invoiceDetails.invoiceDate
                                        .start_period ? (
                                        <>
                                          <CiCalendar />{" "}
                                          <b>
                                            {dateFormateDD(
                                              invoiceDetails.invoiceDate
                                                .start_period
                                            )}
                                          </b>
                                        </>
                                      ) : (
                                        <b>No date</b>
                                      )}
                                    </div>
                                    <div>
                                      End Period :{" "}
                                      {invoiceDetails.invoiceDate.end_period ? (
                                        <>
                                          <b>
                                            <CiCalendar />{" "}
                                            {dateFormateDD(
                                              invoiceDetails.invoiceDate
                                                .end_period
                                            )}
                                          </b>
                                        </>
                                      ) : (
                                        <b>No date</b>
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    Total Count : <b>{dataCount.totalCount}</b>
                                  </div>
                                </div>
                                <div
                                  className={`table-responsive-sm ${styles.responsive}`}
                                >
                                  <TableContainer
                                    className={`${styles.joinedCanidate}`}
                                  >
                                    <Table
                                      stickyHeader
                                      aria-label="sticky table"
                                      className={``}
                                    >
                                      <TableHead className={`${styles.Header}`}>
                                        <TableRow>
                                          <StyledTableCell width={30}>
                                            Candidate&nbsp;Name
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Replaced&nbsp;Candidate
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Job&nbsp;Category
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Joined&nbsp;Date
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Joined&nbsp;day's
                                          </StyledTableCell>
                                          <StyledTableCell width={30}>
                                            Left&nbsp;Date
                                          </StyledTableCell>
                                          <StyledTableCell>CTC</StyledTableCell>
                                          <StyledTableCell>
                                            Employee&nbsp;ID
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Department
                                          </StyledTableCell>
                                          <StyledTableCell>
                                            Assigned&nbsp;by
                                          </StyledTableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {loading ? (
                                          <TableRow>
                                            <StyledTableCell
                                              colSpan="8"
                                              style={{ textAlign: "center" }}
                                            >
                                              <div className="d-flex align-items-center justify-content-center mt-5">
                                                <div className="spinner-border spinner-border-sm text-dark"></div>
                                              </div>
                                            </StyledTableCell>
                                          </TableRow>
                                        ) : invoiceDetails.invoiceCandidateDate &&
                                          invoiceDetails.invoiceCandidateDate
                                            .length > 0 ? (
                                          invoiceDetails.invoiceCandidateDate.map(
                                            (item, index) => (
                                              <TableRow
                                                key={index}
                                                className={`${
                                                  item.is_replacement_required ===
                                                  1
                                                    ? styles.bgColor
                                                    : ""
                                                }`}
                                              >
                                                <StyledTableCell>
                                                  <div
                                                    className={`${styles.invoiceNo}`}
                                                    onClick={() => {
                                                      handleCandidateDetails(
                                                        item.can_id,
                                                        "RegisterCandidate"
                                                      );
                                                    }}
                                                  >
                                                    {item.candidate_first_name}
                                                    {item.candidate_last_name !=
                                                    null
                                                      ? capitalizeWords(
                                                          item.candidate_last_name
                                                        )
                                                      : ""}
                                                  </div>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  <div
                                                    className={`${styles.invoiceNo}`}
                                                    onClick={() => {
                                                      if (
                                                        item.replace_with_can_id !=
                                                        null
                                                      ) {
                                                        handleCandidateDetails(
                                                          item.replace_with_can_id,
                                                          "RegisterCandidate"
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    {item.replaced_candidate_first_name !=
                                                    null
                                                      ? item.replaced_candidate_first_name
                                                      : "-"}
                                                    {item.replaced_candidate_last_name !=
                                                    null
                                                      ? item.replaced_candidate_last_name
                                                      : ""}
                                                  </div>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {item.job_category
                                                    ? textTruncate(
                                                        capitalizeWords(
                                                          item.job_category
                                                        ),
                                                        20
                                                      )
                                                    : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {dateFormateDD(
                                                    item.joined_on
                                                  )}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {calculateDuration(
                                                    item.joined_on
                                                  )}{" "}
                                                  day(s)
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {item.candidate_left_the_company_on
                                                    ? dateFormateDD(
                                                        item.candidate_left_the_company_on
                                                      )
                                                    : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {item.actual_ctc}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {item.employee_id
                                                    ? item.employee_id
                                                    : "-"}
                                                  {/* {item.employee_id} */}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {item.department
                                                    ? textTruncate(
                                                        capitalizeWords(
                                                          item.department
                                                        ),
                                                        20
                                                      )
                                                    : "-"}
                                                  {/* {item.department} */}
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                  {
                                                    adminName[
                                                      adminid.indexOf(
                                                        item.admin_id
                                                      )
                                                    ]
                                                  }
                                                </StyledTableCell>
                                              </TableRow>
                                            )
                                          )
                                        ) : (
                                          <TableRow>
                                            <StyledTableCell
                                              colSpan="6"
                                              style={{
                                                textAlign: "center",
                                                color: "red",
                                              }}
                                            >
                                              <div className="mt-5">
                                                No data available
                                              </div>
                                            </StyledTableCell>
                                          </TableRow>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>
                                <div className="d-flex justify-content-center align-items-center mt-4 ">
                                  <Stack spacing={2}>
                                    <Pagination
                                      count={dataCount.totalPage}
                                      onChange={candidatePagination}
                                      variant="outlined"
                                      shape="rounded"
                                      color="success"
                                      size="medium"
                                    />
                                  </Stack>
                                </div>
                              </p>
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {openInvoiceDatails && (
                <>
                  <MyModal>
                    <ModalContainer
                      zIndex={10005}
                      childComponent={
                        <>
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <div>
                              <b className="fs-4">Invoice</b>{" "}
                            </div>
                            <div>
                              <button
                                className="btn btn-danger"
                                onClick={() => setOpenInvoiceDetails(false)}
                              >
                                <AiOutlineClose />
                              </button>
                            </div>
                          </div>
                          <div
                            style={{
                              width: "900px",
                              height: "70vh",
                              overflowY: "auto",
                              // overflowX: "hidden",
                            }}
                          >
                            <Document
                              ref={documentRef}
                              data={formData}
                              empId={empId}
                              invoicecategory={invoceCategory}
                              invoiceNumber={invoiceNumber}
                            />
                          </div>
                          <div className="mt-2 d-flex align-items-center justify-content-end">
                            <button
                              className="btn btn-outline-success"
                              onClick={handleClickDownloadInvoice}
                              disabled={downloadStatus !== "Download"}
                            >
                              <FaDownload /> {downloadStatus}
                            </button>
                          </div>
                        </>
                      }
                    />
                  </MyModal>
                </>
              )}
              {openNotes && (
                <MyModal>
                  <ModalContainer
                    zIndex={1003}
                    childComponent={
                      <>
                        <div style={{ width: "400px" }}>
                          <div className="text-center mb-3">
                            <b>Add Notes</b>
                          </div>
                          <form
                            action=""
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleNotesSubmit();
                            }}
                          >
                            <textarea
                              type="text"
                              name="notes"
                              value={notes}
                              className={`p-2 mb-2 form-control ${styles["customStatusInput"]}`}
                              onChange={(e) => {
                                setnotes(e.target.value);
                              }}
                              placeholder="Enter notes"
                              required
                            />
                            <div className="d-flex justify-content-end gap-2">
                              <button
                                className="btn btn-danger"
                                onClick={() => setOpenNotes(false)}
                              >
                                Close
                              </button>
                              <button className="btn btn-success">
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </>
                    }
                  />
                </MyModal>
              )}
              {showSuccess && (
                <MyModal>
                  <ModalContainer
                    zIndex={2000}
                    childComponent={
                      <SuccessTick HeadText="Successfully Updated" />
                    }
                  />
                </MyModal>
              )}
            </>
          }
        />
      </Detailsshow>
    </div>
  );
};

export default InvoiceDetailsView;
